import Setting from '@/page/member/Setting';
import Category from '@/page/member/Category';
import Archives from '@/page/member/Archives';
import ISetting from '@/page/member/integral/Setting';
import Exchange from '@/page/member/integral/Exchange';
import Plus from '@/page/member/Plus';
import Query from '@/page/member/Query';
import Sett from '@/page/member/ecard/Setting';
import Plan from '@/page/member/ecard/Plan';
import PlusSetting from '@/page/member/Plush/PlusSetting';
import ConsumeRecord from '@/page/member/consume/record';
import RechargeConsumeRecord from '@/page/member/recharge/consumeRecord';
import RechargeRecord from '@/page/member/recharge/record';
import IntegralRecord from '@/page/member/integral/record';
import Birthday from '@/page/member/Birthday'
import MemberGuide from '@/page/member/memberGuide'
import memberRecharge from '@/page/member/ecard/Recharge'
import memberIntegral from '@/page/member/integral/Fluctuate'
import cardStatus from '@/page/member/ecard/Status'
import Gift from '@/page/member/integral/Gift'
import GiftDetail from '@/page/member/integral/GiftDetail'
import ReverseRecharge from '@/page/member/ecard/ReverseRecharge'

export const member = [
  {
    path: '/member/Setting',
    name: 'Setting',
    component: Setting,
    meta: {
      requireAuth: true,
      title: '会员业务设置'
    },
  },
  {
    path: '/member/Category',
    name: 'Category',
    component: Category,
    meta: {
      requireAuth: true,
      title: '会员类别'
    },
  },
  {
    path: '/member/archives',
    name: 'Archives',
    component: Archives,
    meta: {
      requireAuth: true,
      title: '会员档案'
    },
  },
  {
    path: '/member/integral/setting',
    name: 'ISetting',
    component: ISetting,
    meta: {
      requireAuth: true,
      title: '积分设置'
    },
  },
  {
    path: '/member/integral/Exchange',
    name: 'Exchange',
    component: Exchange,
    meta: {
      requireAuth: true,
      title: '积分兑换'
    },
  },
  {
    path: '/member/Plus',
    name: 'Plus',
    component: Plus,
    meta: {
      requireAuth: true,
      title: 'Plus会员中心'
    },
  },
  {
    path: '/member/Query',
    name: 'Query',
    component: Query,
    meta: {
      requireAuth: true,
      title: '会员查询'
    },
  },
  {
    path: '/member/ecard/Setting',
    name: 'Sett',
    component: Sett,
    meta: {
      requireAuth: true,
      title: '储值设置'
    },
  },
  {
    path: '/member/ecard/Plan',
    name: 'Plan',
    component: Plan,
    meta: {
      requireAuth: true,
      title: '储值方案'
    },
  },
  {
    path: '/member/plush/setting',
    name: 'PlusSetting',
    component: PlusSetting,
    meta: {
      requireAuth: true,
      title: 'Plus产品'
    },
  },
  {
    path: '/member/consume/record',
    name: '会员消费记录',
    component: ConsumeRecord,
    meta: {
      requireAuth: true,
      title: '会员消费记录'
    },
  },
  {
    path: '/member/recharge/consume/record',
    name: '储值消费明细',
    component: RechargeConsumeRecord,
    meta: {
      requireAuth: true,
      title: '储值消费明细'
    },
  },
  {
    path: '/member/recharge/record',
    name: '会员充值明细',
    component: RechargeRecord,
    meta: {
      requireAuth: true,
      title: '会员充值明细'
    },
  },
  {
    path: '/member/integral/record',
    name: '积分流水',
    component: IntegralRecord,
    meta: {
      requireAuth: true,
      title: '积分流水'
    },
  },
  {
    path:'/member/birthday',
    name:'会员生日',
    component: Birthday,
    meta:{
      requireAuth: true,
      title: '会员生日'
    }
  },
  {
    path:'/member/guide',
    name:'memberGuide',
    component: MemberGuide,
    meta:{
      requireAuth: true,
      title: '会员系统指南'
    }
  },
  {
    path:'/member/ecard/recharge',
    name:'memberRecharge',
    component: memberRecharge,
    meta:{
      requireAuth: true,
      title: '会员充值'
    }
  },
  {
    path:'/member/integral/fluctuate',
    name:'memberIntegral',
    component: memberIntegral,
    meta:{
      requireAuth: true,
      title: '积分增减'
    }
  },
  {
    path: '/member/state',
    name: 'cardStatus',
    component: cardStatus,
    meta: {
      requireAuth: true,
      title: '卡状态管理'
    }
  },
  {
    path: '/member/integral/gift',
    name: 'Gift',
    component: Gift,
    meta: {
      requireAuth: true,
      title: '礼品管理'
    }
  },
  {
    path: '/member/integral/gift/detail',
    name: 'GiftDetail',
    component: GiftDetail,
    meta: {
      requireAuth: true,
      title: '礼品兑换明细'
    }
  },
  {
    path: '/member/ecard/reverse/recharge',
    name: 'ReverseRecharge',
    component: ReverseRecharge,
    meta: {
      requireAuth: true,
      title: '会员反充值'
    }
  },
];



// WEBPACK FOOTER //
// ./src/router/member.route.js